import { useContext, useEffect } from 'react'

import { ComposerContext } from '../ComposerContext'
import { installZustandToEditorStateMirror } from './installZustandToEditorStateMirror'
import { useEditorStateEnabled } from './useEditorStateEnabled'

/**
 * Mount the Zustand→Flux `editorState` write-back mirror (CORE-7187 Phase 3)
 * while `composer-zustand-editor-state` is on. Off: a no-op — `EditorWrapper`'s
 * `onEditorStateChange` still dispatches straight to Flux, unchanged.
 *
 * Must run inside `ComposerContext.Provider`.
 */
export function useEditorStateMirror(): void {
  const store = useContext(ComposerContext)
  if (!store) {
    throw new Error('useEditorStateMirror must be used within ComposerProvider')
  }
  const editorStateEnabled = useEditorStateEnabled()

  useEffect(() => {
    if (!editorStateEnabled) return

    const unsubscribe = installZustandToEditorStateMirror(store)
    return unsubscribe
  }, [store, editorStateEnabled])
}
